/* eslint-disable */
//tslint:disable

export interface INotificationForDesktopSchema {
  /** Идентификатор уведомления. Автоинкремент **/
  id: number;
  /** Флаг прочитанности уведомления в ЦУ **/
  isRead: boolean;
  /** Ссылка на фото в уведомлении **/
  mediaUrl?: string | null;
  /** Тип уведомления **/
  notificationType: ENotificationType;
  /** Дополнительные данные для веб-пуша **/
  payload?: any | null;
  /** Текст уведомления **/
  text: string;
  /** Название уведомления **/
  title: string;
  /** Дата обновления уведомления, для отображения на вебе **/
  updateDatetime: string;
  /** Timestamp обновления уведомления. По этому полю построен keyset для пагинации **/
  updateTimestamp: number;
  /** Ссылка для перехода по клику **/
  url: string;
  /** Уведомление создано с отправкой мобильного пуша. Требуется для аналитики **/
  withWebPush?: boolean | null;
}

export enum ENotificationType {
  /** Напоминание о брошеной форме подачи **/
  AbandonedAddform = 'abandonedAddform',
  /** Пуш о новых сообщениях за прошлый день в чате **/
  ChatsMany = 'chatsMany',
  /** Пуш о новом сообщении в чате **/
  ChatsOne = 'chatsOne',
  /** Пуши по сервисам и возможностям ЦИАН **/
  CianServices = 'cianServices',
  /** Истек срок публикации объявления **/
  DeactivatedAnnouncement = 'deactivatedAnnouncement',
  /** Пуши об успешном прохождении скоринга арендатором **/
  DealRentScoringCompleted = 'dealRentScoringCompleted',
  /** Пуши о проваленном прохождении скоринга арендатором **/
  DealRentScoringFailed = 'dealRentScoringFailed',
  /** Универсальный тип пушей для сделки в продаже **/
  DealSaleUniversal = 'dealSaleUniversal',
  /** Пуши по спросу **/
  Demand = 'demand',
  /** Пуш по пакетам заявок спроса **/
  DemandMessagePackage = 'demandMessagePackage',
  /** Новая версия пушей по спросу **/
  DemandNew = 'demandNew',
  /** Пуш об изменении цены дубля **/
  DuplicatePriceChanged = 'duplicatePriceChanged',
  /** Цена изменилась в избранном объявлении **/
  FavoritePriceChanged = 'favoritePriceChanged',
  /** Пуш по последнему поиску **/
  LastSearch = 'lastSearch',
  /** Пуш о новом пропущенном звонке по объекту **/
  MissedCall = 'missedCall',
  /** Пуш о новых пропущенных звонках **/
  MissedCalls = 'missedCalls',
  /** Пуши о новых анкетах для обьявления в сделке **/
  NewProfileForOfferInDeal = 'newProfileForOfferInDeal',
  /** Пуш о новом запросе на показ объекта недвижимости **/
  NewRealtyDemonstration = 'newRealtyDemonstration',
  /** Не поддерживаемый тип пуша в мобильных приложениях. Нужен для тестирования - не удалять. **/
  NotSupportedPush = 'notSupportedPush',
  /** Пуш найден новый дубль объявления **/
  OfferNewDuplicateFound = 'offerNewDuplicateFound',
  /** Пуш объявлений в домах из избранного **/
  OffersFavoriteHouse = 'offersFavoriteHouse',
  /** Пуши для онбординга-книжки **/
  Onbording = 'onbording',
  /** Пуш об оценке на калькулятор недвижимости **/
  PriceEstimator = 'priceEstimator',
  /** Рекомендованные обхявления **/
  RecommendedOffers = 'recommendedOffers',
  /** Пуш-напоминание о новом показе объекта недвижимости **/
  RemindNewRealtyDemonstration = 'remindNewRealtyDemonstration',
  /** Пуш-вопрос состоялся ли показ объекта недвижимости **/
  RemindPlannedRealtyDemonstration = 'remindPlannedRealtyDemonstration',
  /** Оценка специалиста **/
  ReviewSpecialist = 'reviewSpecialist',
  /** Пуш при новой информации в отзывах **/
  Reviews = 'reviews',
  /** Закончилась проверка собственника в Росреестре **/
  RosreestrCheckCompleted = 'rosreestrCheckCompleted',
  /** Пуши о прохождении проверки арендатора в безопасной аренде (успешное или неуспешное) **/
  SafeRentScoring = 'safeRentScoring',
  /** Новое объявление в сохраненном поиске **/
  SavedSearchNewOffer = 'savedSearchNewOffer',
  /** Пуш с данным онбординга из mobile-app-onboarding **/
  ShowOnboarding = 'showOnboarding',
  /** Пуши вместо СМС **/
  SmsPush = 'smsPush',
  /** Закончилась проверка пользователя в SumSub **/
  SumsubCheckCompleted = 'sumsubCheckCompleted',
  /** Смена типа аккаунта **/
  SwitchAccountType = 'switchAccountType',
  /** Универсальные уведомления **/
  UniversalNotification = 'universalNotification',
  /** Пуши от zendesk **/
  Zendesk = 'zendesk',
}
